import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Retry: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#retry-clip)">
      <path
        d="M2.10059 4.23079C3.34452 2.28784 5.52196 1 8.00021 1C11.8663 1 15.0003 4.13403 15.0003 8.00005"
        stroke="currentColor"
        strokeWidth="1.65789"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8997 11.7693C12.6557 13.7123 10.4783 15.0001 8.00005 15.0001C4.13403 15.0001 1 11.8661 1 8"
        stroke="currentColor"
        strokeWidth="1.65789"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.07715 1.53809V4.23041H4.76948"
        stroke="currentColor"
        strokeWidth="1.65789"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9228 14.4619V11.7695H11.2305"
        stroke="currentColor"
        strokeWidth="1.65789"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="retry-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
